// removed by extract-text-webpack-plugin
module.exports = {"dcUnitContainer":"UInF3KPyNbK33ZQIJZmzE","dryingCleaningUnit":"_2R8Qre5DFwJVelBmbPiVOq","dcLevel":"_36TrejIyXHu0IYKUXiobpr","dcLevelWave":"_154AkvKh1tz6yMSBlUZtX3","wheat":"_2icbUCDFKidDOzgup4E1lE","rape":"bMtqoW0b_z10VPZHCoXB8","soy":"_3cvO0F36jILPaBcDXl-A_-","corn":"_2HtXNx7BoSubP8jL1EoN","sunflower":"_2E4PLwyBx_BVsVc6LWsMJr","idle":"_1jhzPMAVe1xHuFUwya0z2w","clogged":"_4QqB5SlFdfkpVc9hIjYQZ","dcWave":"_2loY8cSE7bz3Xke-5fcFS0","dcProductivity":"_2ZwRS-5XVbaRYwiXXPvsOQ","cloggedDCUnit":"_2bzzLuOtc_3mZRzJRYGAJu"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Game/SubComponents/DCUnit/index.css
// module id = 193
// module chunks = 0